<div class="headersp infoHead">
  <i class="far fa-info-circle" style="font-size:18px"></i> &nbsp;Communiquez avec un de nos conseillers par message ou par téléphone.
  <span class="closeheadsp closeInfoHead">
    <i class="fas fa-times"></i>
  </span>
</div>
<div class="contblocsp1">
  <div class="blocmessage ui-card">
    <div class="ui-card__header ui-card__header--bordered">
      <h2 class="ui-card__title"><i class="far fa-envelope"></i> &nbsp; Support</h2>
    </div>
    <div class="ui-card__body">
      <p class="txtsp">
        Besoin d'un coup de main ? Envoyez-nous un message et nous ferons en sorte d'y répondre dans les plus brefs délais.
      </p>
      <div class="contframemess">
        <!-- <div class="formessp">
            <div class="ui-form-group">
              <input type="text" placeholder="Votre adresse e-mail" class="boc-input">
            </div>
            <div class="ui-form-group">
              <input type="text" placeholder="Objet du message" class="boc-input">
            </div>
            <div class="ui-form-group">
              <textarea placeholder="Votre message" class="ui-textarea textarea-message"></textarea>
            </div>
            <button type="button" class="ui-btn ui-btn--primary ui-btn--sm ui-btn--auto">
              Envoyer &nbsp; <i class="fas fa-paper-plane"></i>
            </button>
        </div> -->
        <iframe title="Feedback Form" class="freshwidget freshwidget-embedded-form" id="freshwidget-embedded-form" src="https://wilout.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&formTitle=+&submitTitle=Envoyer&submitThanks=Votre+message+a+bien+%C3%A9t%C3%A9+transmis.+Notre+%C3%A9quipe+support+vous+apportera+une+r%C3%A9ponse+dans+les+plus+brefs+d%C3%A9lais.&screenshot=Non&searchArea=no" scrolling="no" height="400px" width="100%" frameborder="0" style="margin-top:-40px"></iframe>
      </div>
      <div class="cachframe">
      </div>
    </div>
  </div>
</div>
<div class="contblocsp2">
  <div class="bloccontact ui-card">
    <div class="ui-card__header ui-card__header--bordered">
      <h2 class="ui-card__title"><i class="fas fa-headset"></i> &nbsp; Contacts</h2>
    </div>
    <div class="ui-card__body">
      <p class="txtsp">
        Contactez notre équipe pour obtenir un accompagnement personnalisé sur la mise en place et l'utilisation de Wilout CONTROL.
      </p>
      <a href="mailto:support@wilout.com?subject=Demande d'aide / d'accompagnement" class="btncontact-link">
        <button type="button" class="ui-btn ui-btn--primary ui-btn--sm ui-btn--auto btncontact-pos">
          <i class="fas fa-envelope"></i> &nbsp; Envoyer un message
        </button>
      </a>
      <div class="txtcontact">
        <span class="contTT"><i class="fad fa-phone-rotary"></i></span> &nbsp; Telephone : &nbsp; <span class="txtcontact-detail">+ 33 (0) 4 83 39 77 54</span> &nbsp;<span class="txtcontact-hours">- &nbsp;Du lundi au vendredi de 9h a 18h.</span>
        <br><br>
        <i class="fad fa-mailbox"></i> &nbsp; E-mail : &nbsp; <span class="txtcontact-detail">support&#64;wilout.com</span>
      </div>
    </div>
  </div>
</div>
<div class="fdpopedit">
</div>
